import { render, staticRenderFns } from "./ActivationContentMetricsScreenshot.vue?vue&type=template&id=a1187c16&scoped=true&"
import script from "./ActivationContentMetricsScreenshot.vue?vue&type=script&lang=js&"
export * from "./ActivationContentMetricsScreenshot.vue?vue&type=script&lang=js&"
import style0 from "./ActivationContentMetricsScreenshot.vue?vue&type=style&index=0&id=a1187c16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1187c16",
  null
  
)

export default component.exports